module.exports = __webpack_public_path__ + "img/icons B_40.ad50a3bb.svg";